'use client';

import { useEffect, useState } from 'react';
import { MockDatabase } from '../services/MockDatabaseClass';

let mockDbInstance: MockDatabase | null = null;

export function useMockDatabase() {
  const [db, setDb] = useState<MockDatabase | null>(null);

  useEffect(() => {
    // Initialize the database only on the client side
    if (!mockDbInstance) {
      mockDbInstance = MockDatabase.getInstance();
    }
    setDb(mockDbInstance);
  }, []);

  return db;
} 